const truthy = new Set(["1", "true", "yes", "on"]);

function toEnabled(value: string | boolean | undefined): boolean {
  if (typeof value === "boolean") return value;
  if (typeof value !== "string") return false;
  return truthy.has(value.trim().toLowerCase());
}

const env = import.meta.env;
/** Не задано в .env (Docker/CI) — как в .env.example: по умолчанию включать UI work items. */
const workItemsEnv = env.VITE_WORK_ITEMS_UI_ENABLED;
const modulesEnv = {
  oi: env.VITE_MODULE_OI_ENABLED,
  rd: env.VITE_MODULE_RD_ENABLED,
  go: env.VITE_MODULE_GO_ENABLED,
  udgspz: env.VITE_MODULE_UDGSPZ_ENABLED,
  visualizer: env.VITE_MODULE_VISUALIZER_ENABLED,
  tactical: env.VITE_MODULE_TACTICAL_ENABLED,
};

export type ModuleFeatureFlags = {
  workItemsUiEnabled: boolean;
  moduleOiEnabled: boolean;
  moduleRdEnabled: boolean;
  moduleGoEnabled: boolean;
  moduleUdgspzEnabled: boolean;
  moduleVisualizerEnabled: boolean;
  moduleTacticalEnabled: boolean;
  moduleFeedbackEnabled: boolean;
  moduleOnboardingEnabled: boolean;
  moduleChatEnabled: boolean;
};

/** Build-time fallback (Vite). После bootstrap API перекрывает эти значения. */
export const envFeatureFlags: ModuleFeatureFlags = {
  workItemsUiEnabled: toEnabled(
    workItemsEnv === undefined || workItemsEnv === "" ? "true" : (workItemsEnv as string),
  ),
  moduleOiEnabled: toEnabled(
    modulesEnv.oi === undefined || modulesEnv.oi === "" ? "true" : (modulesEnv.oi as string),
  ),
  moduleRdEnabled: toEnabled(modulesEnv.rd === undefined || modulesEnv.rd === "" ? "true" : (modulesEnv.rd as string)),
  moduleGoEnabled: toEnabled(modulesEnv.go === undefined || modulesEnv.go === "" ? "true" : (modulesEnv.go as string)),
  moduleUdgspzEnabled: toEnabled(
    modulesEnv.udgspz === undefined || modulesEnv.udgspz === "" ? "true" : (modulesEnv.udgspz as string),
  ),
  moduleVisualizerEnabled: toEnabled(
    modulesEnv.visualizer === undefined || modulesEnv.visualizer === ""
      ? "true"
      : (modulesEnv.visualizer as string),
  ),
  /** По умолчанию выключен — controlled rollout через admin system settings. */
  moduleTacticalEnabled: toEnabled(
    modulesEnv.tactical === undefined || modulesEnv.tactical === ""
      ? "false"
      : (modulesEnv.tactical as string),
  ),
  moduleFeedbackEnabled: true,
  moduleOnboardingEnabled: true,
  moduleChatEnabled: true,
};

/** @deprecated Используйте useModuleFlags(); оставлено как alias env-fallback. */
export const featureFlags = envFeatureFlags;

export type PublicModuleSettingsPayload = {
  moduleOiEnabled?: boolean;
  moduleRdEnabled?: boolean;
  moduleGoEnabled?: boolean;
  moduleUdgspzEnabled?: boolean;
  moduleVisualizerEnabled?: boolean;
  moduleTacticalEnabled?: boolean;
  moduleWorkItemsEnabled?: boolean;
  moduleFeedbackEnabled?: boolean;
  moduleOnboardingEnabled?: boolean;
  moduleChatEnabled?: boolean;
};

/** API wins над Vite (включая переключаемый ОИ). */
export function mergeModuleFlagsFromApi(
  base: ModuleFeatureFlags,
  api: PublicModuleSettingsPayload | null | undefined,
): ModuleFeatureFlags {
  if (!api) return { ...base };
  return {
    moduleOiEnabled: api.moduleOiEnabled ?? base.moduleOiEnabled,
    moduleRdEnabled: api.moduleRdEnabled ?? base.moduleRdEnabled,
    moduleGoEnabled: api.moduleGoEnabled ?? base.moduleGoEnabled,
    moduleUdgspzEnabled: api.moduleUdgspzEnabled ?? base.moduleUdgspzEnabled,
    moduleVisualizerEnabled: api.moduleVisualizerEnabled ?? base.moduleVisualizerEnabled,
    moduleTacticalEnabled: api.moduleTacticalEnabled ?? base.moduleTacticalEnabled,
    workItemsUiEnabled: api.moduleWorkItemsEnabled ?? base.workItemsUiEnabled,
    moduleFeedbackEnabled: api.moduleFeedbackEnabled ?? base.moduleFeedbackEnabled,
    moduleOnboardingEnabled: api.moduleOnboardingEnabled ?? base.moduleOnboardingEnabled,
    moduleChatEnabled: api.moduleChatEnabled ?? base.moduleChatEnabled,
  };
}
